import { render, staticRenderFns } from "./result.vue?vue&type=template&id=53173bad&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"
import style0 from "./result.vue?vue&type=style&index=0&id=53173bad&scoped=true&lang=scss"
import style1 from "./result.vue?vue&type=style&index=1&id=53173bad&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53173bad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/globalsearch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53173bad')) {
      api.createRecord('53173bad', component.options)
    } else {
      api.reload('53173bad', component.options)
    }
    module.hot.accept("./result.vue?vue&type=template&id=53173bad&scoped=true", function () {
      api.rerender('53173bad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/result.vue"
export default component.exports